import { i18n } from '@/plugins/i18n'
import router from '@/router'
import config from '../config'
import { PublicClientApplication } from '@azure/msal-browser';

const logOutMS = async () => {
    const msalInstance = new PublicClientApplication(config.msalConfig)

    await msalInstance
        .logoutPopup({})
        .catch(error => {
            // eslint-disable-next-line 
            console.error(error);
        });
}

export const logout = async () => {

    if(localStorage.getItem('loginMS')) {
        await logOutMS() 
        localStorage.removeItem('loginMS')
    }

     
    localStorage.removeItem('userName')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('role')
    localStorage.removeItem('userId')
    localStorage.removeItem('guid')
    localStorage.removeItem('organization')
    localStorage.removeItem('organizationId')
    localStorage.removeItem('lang')
    localStorage.removeItem('permissions')
    localStorage.removeItem('showNewDashboardSign')
    //location.reload(true)
    let redirectPath = '/' + i18n.locale
    router.push(redirectPath)
}

